import pendingBookings from "../../views/appPlans/pendingBookings.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "pending-bookings";
  const params = ["page", "limit"];

  $stateProvider.state("pendingBookings", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: pendingBookings,
      },
    },
    reloadOnSearch: false,
    data: { title: "Bookings Moderation" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/pendingBooking/pendingBooking.urls.js